import React from 'react';

interface NumberInputProps {
  value: number;
  onChange: (valueString: string) => void;
  min?: number;
  max?: number;
  width?: string;
}

export function NumberInput({ value, onChange, min, max, width }: NumberInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const increment = () => {
    if (max === undefined || value < max) {
      onChange(String(value + 1));
    }
  };

  const decrement = () => {
    if (min === undefined || value > min) {
      onChange(String(value - 1));
    }
  };

  const atMin = min !== undefined && value <= min;
  const atMax = max !== undefined && value >= max;

  return (
    <div className="inline-flex items-center rounded-md border border-border-default overflow-hidden" style={{ width }}>
      <button
        type="button"
        onClick={decrement}
        disabled={atMin}
        className="px-2 py-1 text-sm font-medium bg-bg-muted hover:bg-bg-subtle text-text-secondary disabled:text-text-disabled disabled:cursor-not-allowed transition-colors"
        aria-label="Decrement"
      >
        −
      </button>
      <input
        type="number"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        className="w-full px-1 py-1 bg-bg-input text-text-primary text-sm text-center focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
      />
      <button
        type="button"
        onClick={increment}
        disabled={atMax}
        className="px-2 py-1 text-sm font-medium bg-bg-muted hover:bg-bg-subtle text-text-secondary disabled:text-text-disabled disabled:cursor-not-allowed transition-colors"
        aria-label="Increment"
      >
        +
      </button>
    </div>
  );
}
